import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayDTO } from '../models/gateway';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class GatewayService {
  constructor(private http: HttpClient, private env: EnvironmentService) { }

  getAllGateways(): Observable<GatewayDTO[]> {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncVDI/Gateways/GetAll';
    return this.http.get<GatewayDTO[]>(baseUrl);
  }

  deleteGateway(gw: GatewayDTO) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncVDI/Gateways/Delete';
    const gwObj = JSON.stringify(gw);
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    let options = { headers: headers };

    return this.http.post<any>(baseUrl, gwObj, options);
  }

  addGateway(gw: GatewayDTO) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncVDI/Gateways/Add';
    const gwObj = JSON.stringify(gw);
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    let options = { headers: headers };
    return this.http.post<any>(baseUrl, gwObj, options);
  }

  editGateway(oldGwName: string, newGw: GatewayDTO) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncVDI/Gateways/Update/' + oldGwName;
    const gwObj = JSON.stringify(newGw);
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    let options = { headers: headers };
    return this.http.put<any>(baseUrl, gwObj, options);
  }

  updateGatewayForVM(vmName: string, gateWayName: string) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncVDI/Gateways/Update/GatewayForVM/vmName=' + vmName + '/gateWayName=' + gateWayName;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache')

    return this.http.post<any>(baseUrl, { headers: headers });
  }

  detachGatewayForVM(vmName: string) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncVDI/Gateways/Detach/GatewayForVM/vmName=' + vmName;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache')

    return this.http.post<any>(baseUrl, { headers: headers });
  }
}
